import {
  AccessTime,
  AccessTimeOutlined,
  AccountBalanceOutlined,
  AccountBoxOutlined,
  AccountCircle,
  Add,
  AddBoxOutlined,
  AddCommentOutlined,
  AddLocation,
  AddLocationAlt,
  AddOutlined,
  AddRounded,
  AlternateEmail,
  AltRoute,
  AppShortcut,
  Archive,
  ArrowBack,
  ArrowBackIos,
  ArrowDownward,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  ArrowForwardIos,
  ArrowRight,
  ArrowUpward,
  AssignmentInd,
  Attachment,
  AutoAwesome,
  AutoMode,
  BackupTable,
  BadgeOutlined,
  BalanceOutlined,
  Block,
  BrokenImageOutlined,
  Business,
  BusinessOutlined,
  Cached,
  CalendarMonth,
  CalendarToday,
  Campaign,
  Cancel,
  CancelOutlined,
  CancelRounded,
  Chat,
  ChatBubbleOutline,
  ChatOutlined,
  Check,
  CheckCircle,
  CheckCircleOutline,
  CheckCircleRounded,
  ChecklistOutlined,
  ChevronLeft,
  ChevronRight,
  Circle,
  Clear,
  Close,
  CloseFullscreen,
  CloseOutlined,
  CloudUpload,
  ContactPhoneOutlined,
  ContentCopy,
  ContentPasteOffOutlined,
  Create,
  CreateNewFolder,
  DataObject,
  DateRange,
  Delete,
  DeleteOutline,
  DeleteOutlined,
  Description,
  DescriptionOutlined,
  DnsOutlined,
  DocumentScanner,
  DocumentScannerOutlined,
  DoDisturbAlt,
  DoneAll,
  DoNotDisturbAlt,
  Download,
  Edit,
  EditOutlined,
  EmailOutlined,
  Error,
  ErrorOutline,
  Euro,
  EuroSymbol,
  ExpandLess,
  ExpandMore,
  FactCheck,
  FactCheckOutlined,
  FileCopy,
  FileCopyOutlined,
  FileOpen,
  FileOpenOutlined,
  FileUpload,
  Flip,
  FolderCopy,
  FolderCopyOutlined,
  FolderSpecial,
  FormatListBulleted,
  FormatListNumbered,
  ForumOutlined,
  Grading,
  Handshake,
  Help,
  HelpOutline,
  History,
  Home,
  HorizontalRule,
  HourglassEmpty,
  HourglassTopOutlined,
  Http,
  IndeterminateCheckBoxOutlined,
  Info,
  InfoOutlined,
  InsertDriveFile,
  InsertDriveFileOutlined,
  IosShare,
  Keyboard,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardDoubleArrowLeft,
  LocalShipping,
  LocalShippingOutlined,
  LocalShippingRounded,
  LocationOff,
  LocationOn,
  Lock,
  LockOpenOutlined,
  LockOutlined,
  Logout,
  LogoutOutlined,
  Loop,
  MailOutline,
  MailOutlineOutlined,
  MarkEmailRead,
  MoreHoriz,
  MoreVert,
  NavigateBefore,
  NavigateNext,
  NetworkCheck,
  OpenInFull,
  OpenInNew,
  PaymentsOutlined,
  PeopleAlt,
  PeopleOutline,
  Person,
  PersonAdd,
  PersonAddAltOutlined,
  PersonOutline,
  PersonOutlined,
  Phone,
  PhoneAndroid,
  PhoneOutlined,
  PhotoCamera,
  PictureAsPdf,
  Place,
  PlayArrow,
  PowerSettingsNew,
  PriorityHigh,
  QrCode2,
  QuestionMark,
  RadioButtonUnchecked,
  Receipt,
  ReceiptLong,
  Refresh,
  Remove,
  RemoveDone,
  RemoveRedEye,
  RemoveRounded,
  Replay,
  Restore,
  RocketLaunchOutlined,
  RotateRight,
  RuleOutlined,
  Save,
  Schedule,
  Search,
  SellOutlined,
  Send,
  SendRounded,
  Settings,
  SettingsSharp,
  Share,
  Shield,
  SkipNext,
  StarBorderRounded,
  StarRounded,
  StopCircleOutlined,
  Storage,
  StorefrontOutlined,
  SupportOutlined,
  Sync,
  TableChart,
  TableChartOutlined,
  TableRows,
  ThumbUpRounded,
  TimerOffOutlined,
  TrendingDown,
  TrendingUpOutlined,
  Tune,
  Undo,
  UnfoldLess,
  UnfoldMore,
  Upload,
  VerifiedOutlined,
  VerifiedUser,
  VerifiedUserOutlined,
  Videocam,
  ViewWeek,
  Visibility,
  VisibilityOff,
  WarehouseRounded,
  Warning,
  WarningAmber,
  WarningRounded,
  WorkOutline,
  YardOutlined,
  ZoomIn,
  ZoomOut,
  ZoomOutMap,
} from '@mui/icons-material';

import { type IconGlyph } from '../types';

export const MUI_ICONS = {
  accessTime: AccessTime,
  accessTimeOutlined: AccessTimeOutlined,
  accountBalanceOutlined: AccountBalanceOutlined,
  accountCircle: AccountCircle,
  add: Add,
  addBoxOutlined: AddBoxOutlined,
  addCommentOutlined: AddCommentOutlined,
  addLocation: AddLocation,
  addLocationAlt: AddLocationAlt,
  addOutlined: AddOutlined,
  address: Place,
  addRounded: AddRounded,
  ai: AutoAwesome,
  aiExtraction: AppShortcut,
  announce: Campaign,
  archive: Archive,
  arrowBack: ArrowBack,
  arrowBackIos: ArrowBackIos,
  arrowDown: ArrowDownward,
  arrowDropUp: ArrowDropUp,
  arrowForward: ArrowForward,
  arrowForwardIos: ArrowForwardIos,
  arrowRight: ArrowRight,
  arrowUp: ArrowUpward,
  assign: AssignmentInd,
  attachment: Attachment,
  backupTable: BackupTable,
  badgeOutlined: BadgeOutlined,
  balanceOutlined: BalanceOutlined,
  block: Block,
  brokenImageOutlined: BrokenImageOutlined,
  businessOutlined: BusinessOutlined,
  cached: Cached,
  calendar: CalendarMonth,
  calendarToday: CalendarToday,
  cancel: Cancel,
  cancelOutlined: CancelOutlined,
  cancelRounded: CancelRounded,
  chatBubbleOutline: ChatBubbleOutline,
  chatOutlined: ChatOutlined,
  check: Check,
  checkCircle: CheckCircle,
  checkCircleOutline: CheckCircleOutline,
  checkCircleRounded: CheckCircleRounded,
  checklistOutlined: ChecklistOutlined,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  circle: Circle,
  clear: Clear,
  close: Close,
  closeOutlined: CloseOutlined,
  cloudUpload: CloudUpload,
  comment: Chat,
  company: Business,
  contactPhoneOutlined: ContactPhoneOutlined,
  contentPasteOffOutlined: ContentPasteOffOutlined,
  copy: ContentCopy,
  create: Create,
  createNewFolder: CreateNewFolder,
  dataExchange: Loop,
  dataObject: DataObject,
  dateRange: DateRange,
  delete: Delete,
  deleteOutline: DeleteOutline,
  deleteOutlined: DeleteOutlined,
  deliveryNote: ReceiptLong,
  deliveryNoteAssigned: Receipt,
  deliveryNoteSigned: Grading,
  description: Description,
  descriptionOutlined: DescriptionOutlined,
  dnsOutlined: DnsOutlined,
  documentScanner: DocumentScanner,
  documentScannerOutlined: DocumentScannerOutlined,
  doDisturbAlt: DoDisturbAlt,
  doneAll: DoneAll,
  download: Download,
  edit: Edit,
  editOutlined: EditOutlined,
  email: AlternateEmail,
  emailOutlined: EmailOutlined,
  endpoint: Http,
  error: Error,
  errorOutline: ErrorOutline,
  euro: Euro,
  euroSymbol: EuroSymbol,
  expand: ExpandMore,
  expandLess: ExpandLess,
  expandSmall: ArrowDropDown,
  factCheck: FactCheck,
  factCheckOutlined: FactCheckOutlined,
  failed: Clear,
  fileCopy: FileCopy,
  fileCopyOutlined: FileCopyOutlined,
  fileOpen: FileOpen,
  fileOpenOutlined: FileOpenOutlined,
  folderCopy: FolderCopy,
  folderCopyOutlined: FolderCopyOutlined,
  folderSpecial: FolderSpecial,
  forbidden: DoNotDisturbAlt,
  forumOutlined: ForumOutlined,
  fullscreenClose: CloseFullscreen,
  fullscreenOpen: OpenInFull,
  handshake: Handshake,
  help: Help,
  helpOutlined: HelpOutline,
  history: History,
  home: Home,
  horizontalLine: HorizontalRule,
  hourglassTopOutlined: HourglassTopOutlined,
  indeterminateCheckBoxOutlined: IndeterminateCheckBoxOutlined,
  info: Info,
  infoOutlined: InfoOutlined,
  insertDriveFile: InsertDriveFile,
  insertDriveFileOutlined: InsertDriveFileOutlined,
  iosShare: IosShare,
  keyboard: Keyboard,
  keyboardArrowDown: KeyboardArrowDown,
  keyboardArrowLeft: KeyboardArrowLeft,
  keyboardArrowRight: KeyboardArrowRight,
  keyboardDoubleArrowLeft: KeyboardDoubleArrowLeft,
  list: FormatListBulleted,
  listNumbered: FormatListNumbered,
  localShipping: LocalShipping,
  localShippingOutlined: LocalShippingOutlined,
  localShippingRounded: LocalShippingRounded,
  locationOff: LocationOff,
  locationOn: LocationOn,
  lock: Lock,
  lockOpenOutlined: LockOpenOutlined,
  lockOutlined: LockOutlined,
  logout: Logout,
  logoutOutlined: LogoutOutlined,
  mailOutline: MailOutline,
  mailOutlineOutlined: MailOutlineOutlined,
  markEmailRead: MarkEmailRead,
  more: MoreHoriz,
  moreVert: MoreVert,
  navigateBefore: NavigateBefore,
  navigateNext: NavigateNext,
  networkCheck: NetworkCheck,
  ocr: Flip,
  off: PowerSettingsNew,
  on: PowerSettingsNew,
  openInNew: OpenInNew,
  paymentsOutlined: PaymentsOutlined,
  peopleAlt: PeopleAlt,
  person: Person,
  personAdd: PersonAddAltOutlined,
  personAddFilled: PersonAdd,
  personOutline: PersonOutline,
  personOutlined: PersonOutlined,
  phone: Phone,
  phoneAndroid: PhoneAndroid,
  phoneOutlined: PhoneOutlined,
  photoCamera: PhotoCamera,
  pictureAsPdf: PictureAsPdf,
  playArrow: PlayArrow,
  priorityHigh: PriorityHigh,
  processWithAI: AutoMode,
  qrCode: QrCode2,
  questionMark: QuestionMark,
  radioButtonUnchecked: RadioButtonUnchecked,
  refresh: Refresh,
  remove: Remove,
  removeDone: RemoveDone,
  removeRedEye: RemoveRedEye,
  removeRounded: RemoveRounded,
  replay: Replay,
  restore: Restore,
  rocketLaunchOutlined: RocketLaunchOutlined,
  rotateRight: RotateRight,
  route: AltRoute,
  ruleOutlined: RuleOutlined,
  save: Save,
  schedule: Schedule,
  search: Search,
  sellOutlined: SellOutlined,
  send: Send,
  sendRounded: SendRounded,
  settings: Settings,
  settingsSharp: SettingsSharp,
  share: Share,
  shield: Shield,
  skipNext: SkipNext,
  starBorderRounded: StarBorderRounded,
  starRounded: StarRounded,
  stopCircleOutlined: StopCircleOutlined,
  storage: Storage,
  storefrontOutlined: StorefrontOutlined,
  supportOutlined: SupportOutlined,
  sync: Sync,
  table: TableChart,
  tableChartOutlined: TableChartOutlined,
  tableRows: TableRows,
  thumbUpRounded: ThumbUpRounded,
  timerOffOutlined: TimerOffOutlined,
  trendDown: TrendingDown,
  trendUp: TrendingUpOutlined,
  tune: Tune,
  undo: Undo,
  unfoldLess: UnfoldLess,
  unfoldMore: UnfoldMore,
  upload: Upload,
  uploadFile: FileUpload,
  user: Person,
  users: PeopleOutline,
  usersActive: AccountBoxOutlined,
  verifiedOutlined: VerifiedOutlined,
  verifiedUser: VerifiedUser,
  verifiedUserOutlined: VerifiedUserOutlined,
  videocam: Videocam,
  viewWeek: ViewWeek,
  visibility: Visibility,
  visibilityOff: VisibilityOff,
  waiting: HourglassEmpty,
  warehouseRounded: WarehouseRounded,
  warningAmber: WarningAmber,
  warningFilled: Warning,
  warningRounded: WarningRounded,
  warningSlim: PriorityHigh,
  workOutline: WorkOutline,
  yardOutlined: YardOutlined,
  zoomFit: ZoomOutMap,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
} as const satisfies Record<string, IconGlyph>;
